import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_protected/fas/projects/$id/_project-tabs/input-process",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/fas/projects/$id/account-mapping",
      params: { id: params.id },
      search: { entityProjectId: search.entityProjectId },
      replace: true,
    });
  },
});
